import GetTargetDate from './GetTargetDate';

function IsDaylightSavings(d) {

    let jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
    let jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();
    return Math.max(jan, jul) !== d.getTimezoneOffset();   
}

function PickEligibility(weekNum, deadline, year) {
    let startDate = GetTargetDate(weekNum, deadline, year);

    console.log('IS DST? ', startDate, IsDaylightSavings(startDate))
    let timeShift = IsDaylightSavings(startDate) ? 1 : 0;
    let currTime = Date.now();
    
    let offsetTime = currTime + (startDate.getTimezoneOffset() * 60 * 1000);
    let numHours;
    
    //  tnf: 00:20 the next day, london: 13:30, normal: 17, thanksgiving_early: 16:30, thanksgiving_middle: 20:30, thanksgiving_end: 00:20 the next day
    //  tnf: 01:20 the next day, london: 14:30, normal: 18, thanksgiving_early: 17:30, thanksgiving_middle: 21:30, thanksgiving_end: 01:20 the next day
    if(deadline === 'tnf') numHours = 25.33;
    else if(deadline === 'london') numHours = 14.5;
    else if(deadline === 'friday_night') numHours = 25.25;
    else if(deadline === 'thanksgiving_morning' || deadline === 'christmas_morning') numHours = 18
    else if(deadline === 'thanksgiving_afternoon' || deadline === 'christmas_afternoon' || deadline === 'saturday_afternoon') numHours = 21.5
    else if(deadline === 'black_friday') numHours = 20
    else if(deadline === 'thanksgiving_night' || deadline === 'christmas_night') numHours = 25.33;
    else if(deadline === 'saturday_night' && weekNum === 16) numHours = 25;
    else if(deadline === 'saturday_night') numHours = 25.33;
    else numHours = 18;

    numHours -= timeShift;
    console.log(startDate.getTime() + (numHours * 60 * 60 * 1000))
    return(offsetTime < startDate.getTime() + (numHours * 60 * 60 * 1000))
}

export default PickEligibility;
